import { useUser } from '../../graphql';
import useIsAuthenticated from '../useIsAuthenticated';

const useAuthenticatedUser = () => {
  const isAuthenticated = useIsAuthenticated();
  const { user } = useUser({
    variables: {},
    skip: !isAuthenticated,
  });
  if (!isAuthenticated) {
    return null;
  }
  return user;
};

export default useAuthenticatedUser;
